import React from 'react';
import './SplashPage.css';
import tcfbLogo from '../../assets/tcfb_logo.png';

const SplashPage: React.FC = () => {
  return (
    <div className="splash-container">
      <div className="splash-content">
        <div className="splash-logo">
          <img src={tcfbLogo} alt="Treasure Coast Food Bank" />
        </div>
        
        <div className="splash-loading">
          <div className="loading-spinner"></div>
          <p>Loading agency data...</p>
        </div>
        
        <div className="splash-message">
          <p>Finding food assistance near you</p>
        </div>
      </div>
    </div>
  );
};

export default SplashPage;